import { getAxiosClient } from "../../axios-client";
import { GetPackagesByIdBody, GetPackagesByIdResponse } from "./types";

const axiosClient = getAxiosClient();
export const getPackageById = async (body: GetPackagesByIdBody) => {
  return await axiosClient.ax.post<GetPackagesByIdResponse>(
    "/Packages/GetById",
    body
  );
};
